import {
  Box,
  Flex,
  InputSelectControl,
  MultiSelectControl,
  type MenuItemProps
} from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import { type FC } from 'react'
import { recipientTypesAtom } from './recipientTypes.atoms'
import type { RecipientType } from './useRecipientsSelection'

const RECIPIENT_TYPE_OPTIONS = [
  { value: 'SIGNER', label: 'Signer' },
  { value: 'CC', label: 'CC' }
]

const { DefaultMenuItem } = MultiSelectControl

export const RecipientMenuItem: FC<MenuItemProps> = props => {
  const { contactTypes, setType, disabled } = useAtomValue(recipientTypesAtom)
  const dataTestId = props['data-testid']

  return (
    <DefaultMenuItem.Container
      {...props}
      minHeight="32px"
      minWidth="400px"
      paddingY={0}
    >
      <Flex grow={1} shrink={1} minWidth={0} alignItems="center" gap="8px">
        <Flex minWidth={0} columnGap="6px" flexWrap="wrap">
          <DefaultMenuItem.Label data-testid={dataTestId}>
            {props.option.label}
          </DefaultMenuItem.Label>
          <DefaultMenuItem.SecondaryLabel data-testid={dataTestId}>
            {props.option.secondaryLabel}
          </DefaultMenuItem.SecondaryLabel>
        </Flex>

        {props.isSelected && (
          <Box
            marginLeft="auto"
            onMouseDown={event => event.stopPropagation()}
            onClick={event => event.stopPropagation()}
          >
            <InputSelectControl
              variant="small"
              data-testid={dataTestId ? `${dataTestId}.type` : undefined}
              options={RECIPIENT_TYPE_OPTIONS}
              value={contactTypes[props.option.value] ?? 'SIGNER'}
              onChange={value =>
                setType(props.option.value, value as RecipientType)
              }
              disabled={disabled || props.isDisabled}
            />
          </Box>
        )}
      </Flex>
    </DefaultMenuItem.Container>
  )
}
